import { AppService } from './AppService';

export class EligibiliteService {
   appService = new AppService();
   //API_URL = 'http://localhost/sfrwebapp/api/'
   constructor() {
      //this.appService = 
      //const API_URL = 'http://localhost/sfrwebapp/api/'
   }

   getEligibiliteByXY(lat, lon) {
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getEligibiliteByXY',
         lat: lat,
         lon: lon
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   getEligibiliteByCoord(lat, lon, domaine, site) {
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getEligibiliteAndOffre',
         lat: lat,
         lon: lon,
         domaine: domaine,
         site: site
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   getEligibiliteByIdImmeuble(idImmeuble, domaine, site) {
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getEligibiliteByIdImmeuble',
         idImmeuble: idImmeuble,
         domaine: domaine,
         site: site
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   
   getOffresMobile(domaine, site) {
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getOffresMobile',
         domaine: domaine,
         site: site
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   setFtthLogement(idEligibilite, adrTech) {
      var refPrise = null;
      if(adrTech.infoPrise && adrTech.infoPrise.refPrise)
         refPrise = adrTech.infoPrise.refPrise;
      
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'setFtthLogement',
         idEligibilite: idEligibilite,
         batiment: adrTech.batiment,
         escalier: adrTech.escalier,
         etage: adrTech.etage,
         refPrise: refPrise
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   setFibreLogement(idEligibilite, adrTech) {
      var refPrise = null;
      if(adrTech.infoPrise && adrTech.infoPrise.refPrise)
         refPrise = adrTech.infoPrise.refPrise;
      
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'setFibreLogement',
         idEligibilite: idEligibilite,
         batiment: adrTech.batiment,
         escalier: adrTech.escalier,
         etage: adrTech.etage,
         refPrise: refPrise
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   getCableRues(idEligibilite) {
      
      
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getCableRues',
         idEligibilite: idEligibilite
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   getCableRueNumeros(idEligibilite, code_rivoli) {
      
      
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getCableRueNumeros',
         idEligibilite: idEligibilite,
         code_rivoli: code_rivoli
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   getCableLogements(idEligibilite, batiment, complement_numero_voie, numero_voie, code_rivoli) {
      
      
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'getCableLogements',
         idEligibilite: idEligibilite,
         batiment: batiment,
         complement_numero_voie: complement_numero_voie,
         numero_voie: numero_voie,
         code_rivoli: code_rivoli
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   setCableLogement(idEligibilite, code_rivoli, batiment, complement_numero_voie, escalier, etage,numero_voie) {
      
      
      const url = this.appService.getApiUrl() + 'eligibilite/getEligibilite.php';
      const params = {
         action:'setCableLogement',
         idEligibilite: idEligibilite,
         code_rivoli: code_rivoli,
         batiment: batiment,
         escalier: escalier,
         etage: etage,
         complement_numero_voie: complement_numero_voie,
         numero_voie: numero_voie
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);

         });
   }

   getListeCommunes(site) {
      const url = this.appService.getApiUrl() + 'adresses/adresses.php';
      const params = {
         action: 'listecommunes',
         site: site
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);
      });
   }

   getListeVoies(code_post, lib_commune, sr) {
      const url = this.appService.getApiUrl() + 'adresses/adresses.php';
      const params = {
         action: 'listevoies',
         code_post: code_post,
         lib_commune: lib_commune,
         sr: sr
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);
      });
   }

   getListeNumVoies(code_post, lib_commune, voie, sr) {
      const url = this.appService.getApiUrl() + 'adresses/adresses.php';
      const params = {
         action: 'listenumvoies',
         code_post: code_post,
         lib_commune: lib_commune,
         voie: voie,
         sr: sr
      };
      return this.appService.get(url, { params })
         .then(function (response) {
            
            return response.data

         })
         .catch(function (error) {
            
            throw new Error(error);
      });
   }

   getCoordVoie(code_post, lib_commune, voie) {
    const url = this.appService.getApiUrl() + 'adresses/adresses.php';
    const params = {
       action: 'getCoordVoie',
       code_post: code_post,
       lib_commune: lib_commune,
       voie: voie
    };
    return this.appService.get(url, { params })
       .then(function (response) {
          
          return response.data

       })
       .catch(function (error) {
          
            throw new Error(error);
    });
 }

}